
<textarea type="text" [(ngModel)]="value" rows="5" pInputTextarea [placeholder]="formMetaField.placeholder || ''"
          style="width: 100%;" [required]="formMetaField.required" [disabled]="isReadOnly"></textarea>
